import { create, tsx } from '@dojo/framework/core/vdom';

const fullImgUrl = require('../assets/images/misc/open-graph.png');
// BTR does not strip this URL of the host so do it manually
// https://github.com/dojo/webpack-contrib/issues/327
const openGraphImg = fullImgUrl.substr(fullImgUrl.lastIndexOf('/') + 1);

export interface HeadProperties {
	title: string;
	description: string;
	noindex?: boolean;
}

const factory = create().properties<HeadProperties>();

export const Head = factory(function Head({ properties }) {
	const { description, title, noindex = false } = properties();
	const url = `https://www.sitepen.com${window.location.pathname}`;

	return (
		<head>
			<title>{title}</title>
			<meta name="description" content={description} />
			{noindex ? (
				<meta name="robots" content="noindex" />
			) : (
				<meta name="robots" content="index, follow" />
			)}
			<meta
				name="googlebot"
				content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
			/>
			<meta
				name="bingbot"
				content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
			/>
			<link rel="canonical" href={url} />
			<meta property="og:locale" content="en_US" />
			<meta property="og:type" content="article" />
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:url" content={url} />
			<meta property="og:site_name" content="SitePen" />
			<meta property="article:publisher" content="https://www.facebook.com/SitePen" />
			<meta property="og:image" content={`https://www.sitepen.com/${openGraphImg}`} />
			<meta property="og:image:width" content="1200" />
			<meta property="og:image:height" content="630" />
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:title" content={title} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:creator" content="@SitePen" />
			<meta name="twitter:site" content="@SitePen" />
		</head>
	);
});

export default Head;
